module.exports = __webpack_public_path__ + "static/media/number8.64c26edd.mp3";